import { render, staticRenderFns } from "./PatriotPayrollDetailsView.vue?vue&type=template&id=2a4c47d8&scoped=true&"
import script from "./PatriotPayrollDetailsView.vue?vue&type=script&lang=ts&"
export * from "./PatriotPayrollDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c47d8",
  null
  
)

export default component.exports